(function () {
  var key = 'alvMoonCloseAfterCartReturn';

  if (location.pathname === '/cart') {
    document.addEventListener('click', function (event) {
      if (event.target.closest('#moonbundle-cart-drawer .moonbundle-cart-drawer-close')) {
        var stamp = String(Date.now());
        sessionStorage.setItem(key, stamp);
        setTimeout(function () {
          if (sessionStorage.getItem(key) === stamp) sessionStorage.removeItem(key);
        }, 10000);
      }
    }, true);
    return;
  }

  var stamp = Number(sessionStorage.getItem(key));
  if (!stamp || Date.now() - stamp > 10000) {
    sessionStorage.removeItem(key);
    return;
  }

  var observer;
  var finished = false;
  function stop() {
    if (finished) return;
    finished = true;
    sessionStorage.removeItem(key);
    if (observer) observer.disconnect();
  }
  function closeReopenedDrawer() {
    if (finished) return;
    var drawer = document.querySelector('#moonbundle-cart-drawer.open[data-open="true"]');
    var button = drawer && drawer.querySelector('.moonbundle-cart-drawer-close');
    if (!button) return;
    stop();
    var app = document.querySelector('moonbundle-cart-drawer-block');
    if (app && typeof app.close === 'function') app.close();
    else button.click();
  }

  function watch() {
    observer = new MutationObserver(closeReopenedDrawer);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class', 'data-open'],
      childList: true,
      subtree: true
    });
    closeReopenedDrawer();
    setTimeout(stop, 7000);
  }
  if (document.documentElement) watch();
  else document.addEventListener('DOMContentLoaded', watch, { once: true });
})();
